import { configureStore } from '@reduxjs/toolkit';
import { accordionSlice } from './accordionSlice';
import { filterSlice } from './filterSlice';
import { firstPageSlice } from './firstPageSlice';
import { globalTooltipSlice } from './globalTooltip';
import { infoCategorySlice } from './infoCategorySlice';
import { managedFarmSlice } from './managedFarmSlice';
import { scrollYSlice } from './scrollYSlice';
import { userJoinSlice } from './userJoinSlice';
import { userOwnTractorSurveySlice } from './userOwnTractorSurveySlice';
import { userProfileSlice } from './userProfileSlice';
import { userSellTractorSurveySlice } from './userSellTractorSurveySlice';
import { monthNavigatorSlice } from './monthNavigatorSlice';

export const store = configureStore({
  reducer: {
    accordion: accordionSlice.reducer,
    scrollY: scrollYSlice.reducer,
    globalTooltip: globalTooltipSlice.reducer,
    userProfile: userProfileSlice.reducer,
    userJoin: userJoinSlice.reducer,
    userOwnTractorSurvey: userOwnTractorSurveySlice.reducer,
    userSellTractorSurvey: userSellTractorSurveySlice.reducer,
    infoCategory: infoCategorySlice.reducer,
    filter: filterSlice.reducer,
    firstPage: firstPageSlice.reducer,
    managedFarm: managedFarmSlice.reducer,
    monthNavigator: monthNavigatorSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
